import { createSelector } from '@reduxjs/toolkit';

const selectUserState = (state) => state.user;

export const selectLoggedInUser = createSelector(
  [selectUserState],
  (state) => state.user
);

export const selectUserLoaded = createSelector(
  [selectUserState],
  (state) => state.userLoaded
);

export const selectUserSettings = createSelector(
  [selectUserState],
  (state) => state.settings
);

export const selectUserSettingsLoaded = createSelector(
  [selectUserState],
  (state) => state.settingsLoaded
);
export const selectLoggedInUserId = createSelector(
  [selectUserState],
  (state) => state.user?.id
);

export const selectUserCoordinates = createSelector(
  [selectUserState],
  (state) => state.coordinates
);
export const selectGeolocationError = createSelector(
  [selectUserState],
  (state) => state.geolocationError
);

export const selectIsUpdatingActiveEmployer = createSelector(
  [selectUserState],
  (state) => state.isUpdatingActiveEmployer
);

export const selectUserActiveEmployerId = createSelector(
  [selectUserSettings],
  (settings) => settings.activeEmployerId
);

export const selectUserActiveEmployerBusinessId = createSelector(
  [selectUserSettings],
  (settings) => settings.activeEmployerBusinessId
);

export const selectUserActiveEmployerInfo = createSelector(
  [selectUserActiveEmployerId, selectUserActiveEmployerBusinessId],
  (activeEmployerId, activeEmployerBusinessId) => ({
    activeEmployerId,
    activeEmployerBusinessId,
  })
);

export const selectCurrentUserWorkTimeSaldoItemsEntities = createSelector(
  [selectUserState],
  (state) => state.workTimeSaldoItems.entities
);

export const selectCurrentUserWorkTimeSaldoItemsArray = createSelector(
  [selectCurrentUserWorkTimeSaldoItemsEntities],
  (entities) => Object.values(entities)
);

export const selectCurrentUserWorkTimeSaldoTotalItem = createSelector(
  [selectCurrentUserWorkTimeSaldoItemsArray],
  (workTimeSaldoItems) =>
    workTimeSaldoItems.find((item) => item.date === 'TOTAL')
);
